export default __webpack_public_path__ + "static/media/auth-img.0780123a.jpg";